import React, { useEffect, useRef } from 'react'
import { useDispatch } from '../../../store'
import { useAuth } from '@labrav/react-components'
import { setPolicyError, setPolicyLoading, setPolicyReady } from './actions'

/**
 * Syncs the library's AuthPolicyProvider state (loading, error) into the
 * app's Redux authorization slice.
 */
export const AuthorizationReduxBridge: React.FC = () => {
  const dispatch = useDispatch()
  const { loading, policyError } = useAuth()
  const hasStartedLoading = useRef(false)

  useEffect(() => {
    if (loading) {
      hasStartedLoading.current = true
      dispatch(setPolicyLoading())
    } else if (policyError) {
      hasStartedLoading.current = true
      dispatch(setPolicyError(policyError))
    } else if (hasStartedLoading.current) {
      dispatch(setPolicyReady())
    }
  }, [dispatch, loading, policyError])

  return null
}
